import { render, staticRenderFns } from "./SemaforoComponent.vue?vue&type=template&id=0361ca0f&scoped=true"
import script from "./SemaforoComponent.vue?vue&type=script&lang=js"
export * from "./SemaforoComponent.vue?vue&type=script&lang=js"
import style0 from "./SemaforoComponent.vue?vue&type=style&index=0&id=0361ca0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0361ca0f",
  null
  
)

export default component.exports